var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.89355V8.89355M24 40.8936V44.8936M8 24.8936H4M12.6282 13.5218L9.7998 10.6934M35.3718 13.5218L38.2002 10.6934M12.6282 36.2736L9.7998 39.102M35.3718 36.2736L38.2002 39.102M44 24.8936H40M34 24.8936C34 30.4164 29.5228 34.8936 24 34.8936C18.4772 34.8936 14 30.4164 14 24.8936C14 19.3707 18.4772 14.8936 24 14.8936C29.5228 14.8936 34 19.3707 34 24.8936Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.8638206017cb88f45d2612781d1a0681.svg";
export { ForwardRef as ReactComponent };